import {isFeatureEnabled} from '@github-ui/feature-flags'
import {ActionList} from '@primer/react'

import type {ReportedContentClassifiers} from '../../mutations/__generated__/minimizeCommentMutation.graphql'

const HIDE_OPTION_LABELS = {
  SPAM: 'Spam',
  ABUSE: 'Abuse',
  OFF_TOPIC: 'Off-topic',
  OUTDATED: 'Outdated',
  DUPLICATE: 'Duplicate',
  RESOLVED: 'Resolved',
} as const

const LOW_QUALITY_OPTION = {LOW_QUALITY: 'Low quality'} as const

export type HIDE_OPTIONS = keyof typeof HIDE_OPTION_LABELS | keyof typeof LOW_QUALITY_OPTION

function getHideOptions(): HIDE_OPTIONS[] {
  const options = Object.keys(HIDE_OPTION_LABELS) as Array<keyof typeof HIDE_OPTION_LABELS>
  if (isFeatureEnabled('low_quality_classifier')) {
    return [...options, 'LOW_QUALITY']
  }
  return options
}

export function getHideOptionLabel(option: HIDE_OPTIONS): string {
  if (option === 'LOW_QUALITY') {
    return LOW_QUALITY_OPTION.LOW_QUALITY
  }
  return HIDE_OPTION_LABELS[option]
}

export function toReportedContentClassifier(reason: HIDE_OPTIONS): ReportedContentClassifiers {
  if (reason === 'LOW_QUALITY') {
    // LOW_QUALITY is not yet in the GraphQL enum; cast only this branch
    return reason
  }
  return reason
}

export const HideCommentActionItems = ({
  setMenuOpen,
  onSelect,
}: {
  setMenuOpen?: (open: boolean) => void
  onSelect: (selectedOption: HIDE_OPTIONS) => void
}) => {
  const options = getHideOptions()

  return (
    <>
      {options.map(option => (
        <ActionList.Item
          key={option}
          aria-label={`Hide comment as ${getHideOptionLabel(option)}`}
          onSelect={() => {
            onSelect(option)
            setMenuOpen?.(false)
          }}
        >
          {getHideOptionLabel(option)}
        </ActionList.Item>
      ))}
    </>
  )
}
